import React, { useMemo } from "react";
import Style from "./index.module.scss";
import {
    GroupActivityList,
    GroupType,
    TeamCanType
} from "../../../../../API/teams";
import { Button, Tooltip } from "antd";
import ListTag from "../ListTag";
import useDeviceType from "../../../../../Utils/useDeviceType";
import { useHistory } from "react-router-dom";
import classNames from "classnames";
import { isTrue } from "../../../../../Utils/filter";

interface Props {
    data: GroupActivityList;
}
const Index = ({ data }: Props) => {
    const history = useHistory();

    const { isMobile, isPC } = useDeviceType();
    const iconType = useMemo(() => {
        switch (data.groupType) {
            case GroupType.Random:
                return {
                    text: "随机小组"
                };
            case GroupType.Static:
                return {
                    text: "固定小组"
                };
            default:
                return {
                    text: "NULL ！"
                };
        }
    }, [data.groupType]);

    return (
        <div className={Style.root}>
            <div
                className={classNames(
                    Style.icon,
                    data.groupType === GroupType.Random && Style.random
                )}>
                {iconType.text}
            </div>
            <div className={Style.middle}>
                <h1 className={Style.title}>
                    <span className={Style.over}>
                        <Tooltip title={data.activityInfo.activityName}>
                            {data.activityInfo.activityName}
                        </Tooltip>
                    </span>
                    <ListTag actStatus={data.statusInfo.status} />
                </h1>
                <h2 className={Style.times}>
                    {data.statusInfo.finished === TeamCanType.yes && (
                        <span className={Style.red}>已结束</span>
                    )}
                    截止时间 &nbsp;
                    {data.activityInfo.deadlineStr}
                </h2>
            </div>
            <div className={Style.right}>
                {isPC && (
                    <Button
                        type="link"
                        size="small"
                        onClick={() =>
                            history.push(
                                `teamDetail/${data?.taskId}/${data?.activityId}/${data?.groupType}/${data?.groupId}/${data?.groupLeaderNo}`
                            )
                        }
                        className={Style.hrefs}>
                        {!isTrue(data.canEdit) && "查看活动"}
                        {isTrue(data.canEdit) && "前往参与"}
                    </Button>
                )}
                {isMobile && (
                    <Button
                        type="link"
                        size="small"
                        onClick={() =>
                            history.push(
                                `teamDetail/${data?.taskId}/${data?.activityId}/${data?.groupType}/${data?.groupId}/${data?.groupLeaderNo}`
                            )
                        }
                        className={Style.hrefs}>
                        查看活动
                    </Button>
                )}
            </div>
        </div>
    );
};

export default Index;
